const Style = {
    base: 'relative block text-sm font-medium text-text-primary',
    error: 'text-error',
    required: `after:ml-1 after:font-semibold after:text-error after:content-['*']`,
};

export default Style;
